import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import LogIn from './LogIn';
import Register from './Register';
import '@ant-design/v5-patch-for-react-19'
import Dash from './Dash';
import Operators from './Operators';
import Stores from './Stores';
import Movements from './Movements';
import Suppliers from './Suppliers';
import Reasons from './Reasons';
import Intro from './Intro';
import Company from './Company';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path='/'  element={<LogIn/>}/>
      <Route path='/register'  element={<Register/>}/>
     {/*  <Route path='/'  element={<Dash/>}/> */}
      <Route path='/operators'  element={<Operators/>}/>
      <Route path='/stores'  element={<Stores/>}/>
      <Route path='/company'  element={<Company/>}/>
      <Route path='/movements'  element={<Movements/>}/>
      <Route path='/suppliers'  element={<Suppliers/>}/>
      <Route path='/reasons'  element={<Reasons/>}/>
      <Route path='/intro'  element={<Intro/>}/>
    </Routes>
  </BrowserRouter>
    
);

